var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.template == "default"
      ? _c("div", [
          _vm.step == "form"
            ? _c("div", { staticClass: "form" }, [
                _c("div", { staticClass: "consult-form__fields" }, [
                  _c("div", { staticClass: "row gx-2" }, [
                    _c("div", { staticClass: "col-sm-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group consult-form__group",
                          class: { "is-invalid": _vm.errors.name },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.contact.name,
                                expression: "contact.name",
                              },
                            ],
                            staticClass: "form-control consult-form__input",
                            attrs: { type: "text", placeholder: "Ваше имя" },
                            domProps: { value: _vm.contact.name },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.contact,
                                  "name",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.errors.name
                            ? _c("p", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.name.join(", ")) +
                                    "\n              "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "form-group consult-form__group",
                          class: { "is-invalid": _vm.errors.phone },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.contact.phone,
                                expression: "contact.phone",
                              },
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "+7(###)###-##-##",
                                expression: "'+7(###)###-##-##'",
                              },
                            ],
                            staticClass: "form-control consult-form__input",
                            attrs: {
                              type: "text",
                              placeholder: "+7(xxx)xxx-xx-xx",
                            },
                            domProps: { value: _vm.contact.phone },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.contact,
                                  "phone",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.errors.phone
                            ? _c("p", { staticClass: "invalid-feedback" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.errors.phone.join(", ")) +
                                    "\n              "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group consult-form__group",
                      class: { "is-invalid": _vm.errors.message },
                    },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contact.message,
                            expression: "contact.message",
                          },
                        ],
                        staticClass: "form-control consult-form__textarea",
                        attrs: { placeholder: "Комментарий или вопрос" },
                        domProps: { value: _vm.contact.message },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.contact,
                              "message",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.errors.message
                        ? _c("p", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.errors.message.join(", ")) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "consult-form__actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary consult-form__btn",
                      attrs: { type: "button" },
                      on: { click: _vm.sendForm },
                    },
                    [_vm._v("Отправить")]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "consult-form__legal" }, [
                    _vm._v(
                      "Отправляя, вы принимаете условия обработки персональных данных"
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.step == "complete"
            ? _c("div", [
                _c("p", { staticClass: "text-success" }, [
                  _vm._v(
                    "\n        Ваше сообщение успешно отправлено! Мы свяжемся с Вами в ближайшее время.\n      "
                  ),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }